import moment from 'moment'
import Vue from 'vue'
import Config from '@/config'

const Utils = {
  buildURL (base, params) {
    const q = Object.keys(params).map(key => [key, params[key]].map(encodeURIComponent).join('=')).join('&')
    return `${base}?${q}`
  },

  relativeShortDate (forDate) {
    let dateFormatStr = 'MMM DD'
    const now = moment(new Date())
    const forDateM = Utils.getMomentDate(forDate)
    const diffDays = forDateM.diff(now, 'days')

    if (now.year() !== forDateM.year()) {
      dateFormatStr = 'MMM DD, YYYY'
    }

    if (Math.abs(diffDays) < (3 * 7)) {
      dateFormatStr = 'ddd, MMM DD'
      const diffNumber = forDateM.date() - now.date()

      if (diffNumber === 0) {
        return 'Today'
      } else if (diffNumber === -1) {
        return 'Yesterday'
      } else if (diffNumber === 1) {
        return 'Tomorrow'
      }
    }

    return forDateM.format(dateFormatStr)
  },

  shortDate (forDate) {
    const today = moment(new Date())
    let format = 'MMM DD'
    if (forDate.year() !== today.year()) {
      format = 'MMM DD, YYYY'
    }

    return forDate.format(format)
  },

  simpleDateString (forDate) {
    return Utils.getMomentDate(forDate).format('MMM DD, YYYY')
  },

  simpleDateTimeString (forDate) {
    return Utils.getMomentDate(forDate).format('DD MMM YYYY, h:mm a')
  },

  relativeTime (forDate) {
    const mdate = Utils.getMomentDate(forDate)
    let timeString = mdate.format('hh:mm a')
    if (mdate.hours() === 0 && mdate.minutes() === 0) {
      timeString = 'midnight'
    }
    return timeString
  },

  relativeShortDateTime (forDate) {
    const dateString = Utils.relativeShortDate(forDate)
    const timeString = Utils.relativeTime(forDate)

    return `${dateString} ${timeString}`
  },

  getMomentDate (forDate) {
    if (moment.isMoment(forDate)) {
      return forDate
    }

    if (!isNaN(forDate)) {
      forDate = moment.unix(forDate)
    } else if (typeof (forDate) === 'string') {
      forDate = moment(forDate)
      // if (forDate.indexOf('+') > -1 || forDate.indexOf('Z') > -1) {
      //   forDate = moment(forDate)
      // } else {
      //   forDate = moment(forDate).utc()
      // }
    }

    return forDate
  },

  momentFormat (forDate, format) {
    return Utils.getMomentDate(forDate).format(format)
  },


  buildStatusClass (status, inProgress) {
    if (inProgress === true) {
      return {
        in_progress: true,
        completed: false,
        partial_completed: false,
        active: false
      }
    }

    return {
      in_progress: false,
      completed: (status === 'completed'),
      partial_completed: (status === 'partial_completed'),
      active: (status !== 'completed' && status !== 'partial_completed')
    }
  },

  capitalise (key, defaultValue) {
    if (key === undefined || key === null) { return defaultValue || '-' }
    if (key.length === 0) { return defaultValue || '' }

    return key.split(/[_\-.]/).map((word) => {
      return word.replace(word[0], word[0].toUpperCase())
    }).join(' ')
  },

  capitaliseUpper (key) {
    return key.split(/[_\-.]/).map((word) => {
      return word.toUpperCase()
    }).join(' ')
  },

  fixCamelCase (text) {
    return text.replace(/([a-z](?=[A-Z]))/g, '$1 ')
  },

  uniqueId () {
    return '_' + Math.random().toString(36).substr(2, 9)
  },

  diffInCalendarDate (fromDate, toDate) {
    const x = fromDate.clone().set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    const y = toDate.clone().set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    return x.diff(y, 'days')
  },

  ballsAsOvers (balls) {
    const over = Math.floor(balls / 6)
    const lballs = balls - (over * 6)

    return `${over}.${lballs}`
  },

  join (listOfItem) {
    return listOfItem.join(', ')
  },

  locale (val, defaultValue) {
    if (val === null || val === undefined) {
      if (defaultValue === undefined) {
        return 'NULL'
      }
      return defaultValue
    }

    return val.toLocaleString()
  },

  mergeArray (dest, toMerge) {
    const len = Math.min(dest.length, toMerge.length)
    for (let i = 0; i < len; i++) {
      dest.splice(i, 1, toMerge[i])
    }

    if (toMerge.length > dest.length) {
      const toAdd = toMerge.slice(dest.length)
      dest.push(...toAdd)
    }
  },
  
  utcToLocalTimeConversion (selectedTime) {
    let utcTimestamp = moment(selectedTime).format("X")
    let localTimestamp =  parseInt(utcTimestamp) + (5.5 * 60 * 60)
    let unixDate = parseInt(localTimestamp)
    let istDate = Utils.simpleDateTimeString(unixDate)
    return istDate
  }
}

Vue.filter('shortDate', Utils.shortDate)
Vue.filter('simpleDate', Utils.simpleDateString)
Vue.filter('simpleDateTimeString', Utils.simpleDateTimeString)
Vue.filter('relativeShortDate', Utils.relativeShortDate)
Vue.filter('relativeShortDateTime', Utils.relativeShortDateTime)
Vue.filter('relativeTime', Utils.relativeTime)
Vue.filter('momentFormat', Utils.momentFormat)
Vue.filter('capitalise', Utils.capitalise)
Vue.filter('capitaliseUpper', Utils.capitaliseUpper)
Vue.filter('fixCamelCase', Utils.fixCamelCase)
Vue.filter('ballsAsOvers', Utils.ballsAsOvers)
Vue.filter('join', Utils.join)
Vue.filter('locale', Utils.locale)
export default Utils
